<aionz-purchase-request-activity-panel
  [purchaseId]="currentPurchaseId"
  [panelTitle]="'Atividade da solicitação'"
  [panelSubtitle]="'#' + (purchase()?.id || '')">
  <div class="accepted-request-detail flex-col">
    <div class="accepted-request-header">
      <div class="accepted-request-title-block">
        @if (purchase()) {
          <div class="accepted-request-title-row">
            <button
              mat-icon-button
              type="button"
              aria-label="Voltar para o quadro"
              class="back-button"
              (click)="handleGoBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>

            <span class="accepted-request-title">{{ purchase()?.title }}</span>
            <button
              mat-icon-button
              type="button"
              class="activity-icon-button"
              aionzTooltip="Atividade da solicitação"
              mode="message"
              aria-label="Abrir a atividade da solicitação"
              (click)="openActivityTab()">
              <mat-icon aria-hidden="true">timeline</mat-icon>
            </button>
          </div>

          <span class="accepted-request-description">{{ purchase()?.description }}</span>

          <div class="accepted-request-meta">
            <mat-basic-chip class="custom-chip custom-id-chip"
              >#{{ purchase()?.id }}</mat-basic-chip
            >

            @if (purchase()?.status?.[0]; as status) {
              <aionz-purchase-request-status [status]="status"></aionz-purchase-request-status>
            }

            <div class="requested-at">
              <mat-icon class="requested-at-icon">calendar_month</mat-icon>
              <span>Solicitado em: {{ purchase()?.requestedAt | date: 'dd/MM/yy' }}</span>
            </div>

            @if (deliveryBranchesSummary().branches.length > 0) {
              <!-- Para onde vão os itens, como no mapa de cotação: a quantidade de locais de um
                   olhar; os nomes no tooltip. -->
              <button
                type="button"
                class="custom-chip comments-chip branches-chip--static"
                [aionzTooltipComponent]="branchesTooltipComponent"
                [aionzTooltipData]="deliveryBranchesSummary()"
                aionzTooltipPosition="below"
                aionzTooltipClass="branches-tooltip"
                mode="message"
                [attr.aria-label]="deliveryBranchesLabel()">
                <mat-icon aria-hidden="true">business</mat-icon>
                {{ deliveryBranchesLabel() }}
              </button>
            }

            @if (activityPanel().commentsCount() !== null) {
              @let commentsCount = activityPanel().commentsCount() ?? 0;
              @let comments =
                commentsCount === 0
                  ? 'Sem comentários'
                  : commentsCount === 1
                    ? '1 comentário'
                    : commentsCount + ' comentários';
              <button
                type="button"
                class="custom-chip comments-chip"
                [aionzTooltip]="commentsCount === 0 ? 'Escrever o primeiro comentário' : 'Abrir os comentários da solicitação'"
                mode="message"
                [attr.aria-label]="'Abrir os comentários da solicitação, ' + comments"
                (click)="openCommentsTab()">
                <mat-icon aria-hidden="true">forum</mat-icon>
                {{ comments }}
              </button>
            }

            @if (expectedDeliveryDateLabel()) {
              <div class="requested-at">
                <mat-icon class="requested-at-icon">calendar_month</mat-icon>
                <span
                  >Data esperada para entrega:
                  {{ expectedDeliveryDateLabel() | date: 'dd/MM/yy' }}</span
                >
              </div>
            }
          </div>
        } @else {
          <div class="accepted-request-title-row">
            <button
              mat-icon-button
              type="button"
              aria-label="Voltar para o quadro"
              class="back-button"
              (click)="handleGoBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="skeleton skeleton-header-title"></div>
          </div>
          <div class="skeleton skeleton-header-description"></div>
          <div class="accepted-request-meta">
            <div class="skeleton skeleton-header-chip"></div>
            <div class="skeleton skeleton-header-chip skeleton-header-chip--status"></div>
            <div class="skeleton skeleton-header-date"></div>
          </div>
        }
      </div>

      <div class="accepted-request-actions">
        <div class="flex-col items-end">
          <seed-button
            matType="stroked"
            [loading]="isSearchingSuppliers()"
            (click)="handleTriggerSupplierSuggestionSearch()">
            <mat-icon>travel_explore</mat-icon>
            Buscar novos fornecedores
          </seed-button>
          @if (lastSupplierSuggestionSearchAt()) {
            <span class="caption text-muted">
              Última busca: {{ lastSupplierSuggestionSearchAt() | date: 'dd/MM/yy HH:mm' }}
            </span>
          }
        </div>

        <!--<button
          mat-button
          color="warn"
          type="button"
          (click)="handleDeclineRequest()">
          Recusar
        </button> -->

        <!-- Botão desabilitado não recebe mouse: o tooltip com o motivo fica no invólucro. -->
        <span
          class="send-for-quote-wrapper"
          [aionzTooltip]="sendForQuoteBlockedReason() ?? ''"
          mode="message"
          [aionzTooltipDisabled]="!sendForQuoteBlockedReason()">
          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="hasItemsWithoutSuppliers()"
            [attr.aria-describedby]="sendForQuoteBlockedReason() ? 'send-for-quote-reason' : null"
            (click)="sendForQuote()">
            Enviar para cotação
          </button>
          @if (sendForQuoteBlockedReason(); as reason) {
            <span
              id="send-for-quote-reason"
              class="visually-hidden"
              >{{ reason }}</span
            >
          }
        </span>
      </div>
    </div>

    <mat-tab-group
      [selectedIndex]="selectedTabIndex()"
      [mat-stretch-tabs]="false"
      (selectedTabChange)="handleTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex-row items-center gap-8">
            <mat-icon>local_offer</mat-icon>
            <span>Itens</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <!-- Aviso de unificação à esquerda e o botão de fornecedores à direita, na mesma linha. -->
          <div class="items-header">
            @if (
              duplicatedItems().length &&
              detailsLoadState() === LoadState.LOADED &&
              items().length > 0
            ) {
              <div
                class="cotai-banner"
                role="status">
                <mat-icon
                  class="cotai-banner-icon cotai-gradient-text"
                  aria-hidden="true"
                  >auto_awesome</mat-icon
                >
                <span class="cotai-banner-text">
                  O Cotai encontrou outra solicitação com os mesmos produtos.
                </span>
                <button
                  mat-button
                  type="button"
                  class="cotai-banner-action"
                  (click)="openMergeDialog()">
                  Ver e unificar
                </button>
              </div>
            }

            <div class="items-toolbar">
              <button
                mat-stroked-button
                type="button"
                class="bulk-supplier-button"
                [disabled]="detailsLoadState() !== LoadState.LOADED || items().length === 0"
                (click)="openBulkSupplierDialog()">
                <mat-icon aria-hidden="true">group_add</mat-icon>
                Adicionar fornecedor aos itens
              </button>
            </div>
          </div>

          <aionz-purchase-request-items-table
            [items]="items()"
            [branchCities]="branchCities()"
            [loadState]="detailsLoadState()"
            [showActions]="true"
            [actions]="tableActions()"
            [allowEditQuantity]="true"
            [suppliersClickable]="true"
            (suppliersClick)="openSuppliersDialog($event)"
            (actionClick)="handleTableAction($event)"
            (quantityChange)="handleQuantityChange($event)" />
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex-row items-center gap-8">
            <mat-icon>attach_file</mat-icon>
            <span>Anexos</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <aionz-purchase-request-attachments
            [purchaseId]="currentPurchaseId"
            [status]="PurchaseRequestStatus.ACCEPTED"></aionz-purchase-request-attachments>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</aionz-purchase-request-activity-panel>
